import React, { memo } from 'react';
import { Box, Typography } from '@mui/material';

const ProgramRow = memo(({
  index,
  style,
  channels,
  filteredPrograms,
  formatTime,
  windowStartTime,
  windowEndTime,
  onClick
}) => {
  return (
    <Box
      key={index}
      style={style}
      sx={{
        display: 'flex',
        position: 'relative',
        height: '50px',
        marginTop: "4px",
      }}
    >
      {filteredPrograms
        .filter((program) => program.id === channels[index].epg_channel_id)
        .map((program, programIndex, arr) => {
          const totalWindowDuration = windowEndTime - windowStartTime;

          const programStartTime = program.start;
          const programEndTime = program.stop;

          const visibleStartTime = Math.max(programStartTime, windowStartTime);
          const visibleEndTime = Math.min(programEndTime, windowEndTime);

          const visibleDuration = visibleEndTime - visibleStartTime;

          if (visibleDuration <= 0) return null;

          // Ensure the offset and width are calculated properly for time alignment
          const offsetPercent = ((visibleStartTime - windowStartTime) / totalWindowDuration) * 100;
          const widthPercent = (visibleDuration / totalWindowDuration) * 100;

          return (
            <Box
              key={programIndex}
              sx={{
                position: "absolute",
                left: `${offsetPercent}%`,
                width: `calc(${widthPercent}% - 6px)`,
                padding: "8px",
                backgroundColor: "#333",
                boxSizing: "border-box",
                overflow: "hidden",
                borderRadius: '2px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'flex-start',
                height: 'calc(100% - 8px)',
                cursor: 'pointer',
                border: '2px solid transparent', // Set an initial transparent border
                '&:hover': {
                  border: '2px solid #039dfc',
                }
              }}
              onClick={(e) => onClick(e, channels[index])}
            >
              <Typography
                color="white"
                sx={{
                  fontSize: 13,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  textAlign: 'left'
                }}
              >
                {program.title}
              </Typography>
            </Box>
          );
        })}

      {filteredPrograms.filter((program) => program.id === channels[index].epg_channel_id).length === 0 && (
        <Box
          sx={{
            width: '100%',
            padding: '8px',
            backgroundColor: '#333',
            borderRadius: '2px',
            height: 'calc(100% - 8px)',
            display: 'flex',
            justifyContent: 'center',
            boxSizing: "border-box",
            flexDirection: 'column',
            alignItems: 'flex-start',
            cursor: 'pointer',
            border: '2px solid transparent', // Set an initial transparent border
            '&:hover': {
              border: '2px solid #039dfc',
            }
          }}
          onClick={(e) => onClick(e, channels[index])}
        >
          <Typography color="white" sx={{ fontSize: 13, textAlign: 'left' }}>No channel information</Typography>
        </Box>
      )}
    </Box>
  );
});

export default ProgramRow;
